export default __webpack_public_path__ + "static/media/958.290418af.png";